import {GuiSettingsDto} from "../../dtos";


import './GuiSelectorItem.scss'
import {Box, Typography} from "@mui/material";
import {AsyncImageWithLoader} from "../imageWithLoader/imageWithLoader";
import React from "react";
import {getIconStyle} from "../../globals/globFunctions";
import {makeStyles} from "@mui/styles";


const useStyles = makeStyles(() => ({
    iconWrapper: (props: any) => ({
        width: `32px`,
        height: `32px`,
        maxWidth: `32px`,
        maxHeight: `32px`,
        borderRadius: "50%",
        // backgroundColor: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& > svg > rect": {
            fill: ((props.styleType === 2 || props.styleType === 3) && props.mainColor) && props.mainColor
        }
    })
}))

interface IGuiSelectorItem {
    guiSettings: GuiSettingsDto
}

const GuiSelectorItem: React.FC<IGuiSelectorItem> = (props) => {
    const iconStyleData = getIconStyle(props.guiSettings?.gusIconContrast || 1);
    const properties = {
        mainColor: props.guiSettings?.gusPrimaryColorRgb,
        styleType: iconStyleData.iconStyleType
    }
    const classes = useStyles(properties);
    const CurrentIconComp = iconStyleData.iconStyleData.promoCompIcon;
    if (props.guiSettings) {
        return (
            <Box className="gui_selector_item">
                <Box
                    sx={{
                        width: "18%"
                    }}
                >
                    <Typography noWrap>
                        {props.guiSettings ? props.guiSettings.gusCaption : ''}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        height: `50px`,
                        minWidth: `100px`,
                        maxWidth: `100px`,
                        maxHeight: `50px`,
                        display: `flex`,
                        alignItems: `center`,
                        backgroundColor: props.guiSettings ? props.guiSettings.gusPrimaryColorRgb : 'white',
                        borderRadius: `5px`,
                        border: `1px solid #888888`,
                    }}
                >
                    {props.guiSettings.gusLogoUrl &&
                        // <Box>
                        //     <img src={props.guiSettings.gusLogoUrl} alt="" style={{
                        //         width: "100%",
                        //         height: "100%",
                        //         padding: "4px"
                        //     }}/>
                        // </Box>
                        <AsyncImageWithLoader
                            src={props.guiSettings.gusLogoUrl}
                            notUploadIcon={(<Typography>No Image</Typography>)}
                        />
                    }
                    {!props.guiSettings.gusLogoUrl && ''}
                </Box>
                {/* <span>{props.guiSettings ? props.guiSettings.gusFontSizePt : ''}px</span>  */}
                {/*<Box className="gui_selector_item_color"*/}
                {/*     style={{backgroundColor: props.guiSettings ? props.guiSettings.gusPrimaryColorRgb : 'white'}}*/}
                {/*></Box>*/}
                <Box className={`gui_font_caption`}
                     sx={{
                         width: "18%"
                     }}
                >
                    <Typography noWrap>
                        {
                            props.guiSettings ?
                                (
                                    props.guiSettings.gusFont === 'OpenSans' ?
                                        'Open Sans' :
                                        (
                                            props.guiSettings.gusFont === 'AlmoniTzar' ?
                                                'Almoni Tzar (Hebrew)' :
                                                (
                                                    props.guiSettings.gusFont === 'OpenSansHeb' ?
                                                        'Open Sans (Hebrew)' :
                                                        props.guiSettings.gusFont
                                                )
                                        )
                                ) :
                                ''
                        }
                    </Typography>
                </Box>
                <Box sx={{
                    height: `100%`,
                    display: `flex`,
                    alignItems: `center`,
                    justifyContent: `center`,
                }}>
                    <Box sx={{
                        width: `50px`,
                        height: `50px`,
                        maxWidth: `50px`,
                        maxHeight: `50px`,
                        // borderRadius: `5px`,
                    }}>
                        {
                            props.guiSettings.gusBackgroundImageUrl && !Boolean(props.guiSettings.gusBackgroundColorRgb)
                                ?
                                <Box
                                    sx={{
                                        width: `50px`,
                                        height: `50px`,
                                        maxWidth: `50px`,
                                        maxHeight: `50px`,
                                        borderRadius: `5px`,
                                        border: `1px solid #888888`,
                                    }}
                                >
                                    <AsyncImageWithLoader
                                        src={props.guiSettings.gusBackgroundImageUrl}
                                        notUploadIcon={(<Typography>No Image</Typography>)}
                                    />
                                </Box>
                                : <div style={{
                                    backgroundColor: props.guiSettings.gusBackgroundColorRgb ? props.guiSettings.gusBackgroundColorRgb : '#ffffff',
                                    height: `100%`,
                                    width: `100%`,
                                    borderRadius: `5px`,
                                    border: `1px solid #888888`,
                                }}/>

                        }
                    </Box>
                </Box>
                <Box sx={{
                    height: `100%`,
                    display: `flex`,
                    alignItems: `center`,
                    justifyContent: `center`,
                }}>
                    <Box className={classes.iconWrapper}>
                        <CurrentIconComp style={{width: "100%", height: "100%"}}/>
                    </Box>
                </Box>
            </Box>
        )

    } else {
        return (
            <></>
        )
    }
}

export default GuiSelectorItem;